export default __webpack_public_path__ + "ec2f5d5a60bb4c5b46ef35e4efcc51e8.png";